const BasicModal = require('../ctrl/basic_modal');

async function open() {
  const modal = BasicModal({
    title: `Temporarily Unavailable`,
    content: `<p>You appear to be <strong>offline</strong>. Please go online to complete this action.</p>`,
    buttons: [
      {
        text: 'Got it!',
        primary: true,
        handler: () => modal.close()
      }
    ]
  });

  return modal.open();
}

module.exports = { open };
